import React, { useState } from "react";
import "./Expander.scss";
import eventTracking from "../../utils/eventTracking";

function Expander(props) {
  const [open, setOpen] = useState(false);
  function onClick() {
    setOpen(!open);
    eventTracking(
      `Kapittel ${props.chapter}`,
      "Infoboks",
      open ? "Lukke" : "Åpne"
    );
  }

  return (
    <div className={props.class + " expander-wrapper"} open={open}>
      <div className="content">{props.content}</div>
      <div
        className="expander"
        data-text={props.content}
        onClick={() => onClick()}
      >
        <div className="line line-one"></div>
        <div className="line line-two"></div>
      </div>
    </div>
  );
}

export default Expander;
